/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BadgeRouteImport } from './routes/badge'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as PassportIndexRouteImport } from './routes/passport/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PassportStampRouteImport } from './routes/passport/stamp'
import { Route as PassportEventsRouteImport } from './routes/passport/events'
import { Route as DemoEnrollRouteImport } from './routes/demo.enroll'
import { Route as AppScanLogsRouteImport } from './routes/_app/scan-logs'
import { Route as AppParticipantsIndexRouteImport } from './routes/_app/participants/index'
import { Route as AppAttendeesIndexRouteImport } from './routes/_app/attendees/index'
import { Route as PassportScanEventIdRouteImport } from './routes/passport/scan.$eventId'
import { Route as PassportEventsEventIdRouteImport } from './routes/passport/events_.$eventId'
import { Route as AppAttendeesImportRouteImport } from './routes/_app/attendees/import'
import { Route as AppAttendeesIdRouteImport } from './routes/_app/attendees/$id'
import { Route as AppAdminStaffRouteImport } from './routes/_app/admin/staff'
import { Route as AppAdminEventSettingsRouteImport } from './routes/_app/admin/event-settings'
import { Route as AppAdminDemoRouteImport } from './routes/_app/admin/demo'
import { Route as AppAdminPassportIndexRouteImport } from './routes/_app/admin/passport/index'
import { Route as AppStaffScanLunchRouteImport } from './routes/_app/staff/scan/lunch'
import { Route as AppStaffScanAttendanceRouteImport } from './routes/_app/staff/scan/attendance'
import { Route as AppAdminPassportNewRouteImport } from './routes/_app/admin/passport/new'
import { Route as AppAdminPassportLogsRouteImport } from './routes/_app/admin/passport/logs'
import { Route as AppAdminPassportEventIdRouteImport } from './routes/_app/admin/passport/$eventId'
import { Route as AppAdminDemoQrGalleryRouteImport } from './routes/_app/admin/demo_.qr-gallery'
import { Route as AppAdminPassportActivitiesActivityIdRouteImport } from './routes/_app/admin/passport/activities.$activityId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BadgeRoute = BadgeRouteImport.update({
  id: '/badge',
  path: '/badge',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportIndexRoute = PassportIndexRouteImport.update({
  id: '/passport/',
  path: '/passport/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const PassportStampRoute = PassportStampRouteImport.update({
  id: '/passport/stamp',
  path: '/passport/stamp',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportEventsRoute = PassportEventsRouteImport.update({
  id: '/passport/events',
  path: '/passport/events',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoEnrollRoute = DemoEnrollRouteImport.update({
  id: '/demo/enroll',
  path: '/demo/enroll',
  getParentRoute: () => rootRouteImport,
} as any)
const AppScanLogsRoute = AppScanLogsRouteImport.update({
  id: '/scan-logs',
  path: '/scan-logs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppParticipantsIndexRoute = AppParticipantsIndexRouteImport.update({
  id: '/participants/',
  path: '/participants/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAttendeesIndexRoute = AppAttendeesIndexRouteImport.update({
  id: '/attendees/',
  path: '/attendees/',
  getParentRoute: () => AppRouteRoute,
} as any)
const PassportScanEventIdRoute = PassportScanEventIdRouteImport.update({
  id: '/passport/scan/$eventId',
  path: '/passport/scan/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const PassportEventsEventIdRoute = PassportEventsEventIdRouteImport.update({
  id: '/passport/events_/$eventId',
  path: '/passport/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAttendeesImportRoute = AppAttendeesImportRouteImport.update({
  id: '/attendees/import',
  path: '/attendees/import',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAttendeesIdRoute = AppAttendeesIdRouteImport.update({
  id: '/attendees/$id',
  path: '/attendees/$id',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminStaffRoute = AppAdminStaffRouteImport.update({
  id: '/admin/staff',
  path: '/admin/staff',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminEventSettingsRoute = AppAdminEventSettingsRouteImport.update({
  id: '/admin/event-settings',
  path: '/admin/event-settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminDemoRoute = AppAdminDemoRouteImport.update({
  id: '/admin/demo',
  path: '/admin/demo',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminPassportIndexRoute = AppAdminPassportIndexRouteImport.update({
  id: '/admin/passport/',
  path: '/admin/passport/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStaffScanLunchRoute = AppStaffScanLunchRouteImport.update({
  id: '/staff/scan/lunch',
  path: '/staff/scan/lunch',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppStaffScanAttendanceRoute = AppStaffScanAttendanceRouteImport.update({
  id: '/staff/scan/attendance',
  path: '/staff/scan/attendance',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminPassportNewRoute = AppAdminPassportNewRouteImport.update({
  id: '/admin/passport/new',
  path: '/admin/passport/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminPassportLogsRoute = AppAdminPassportLogsRouteImport.update({
  id: '/admin/passport/logs',
  path: '/admin/passport/logs',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminPassportEventIdRoute = AppAdminPassportEventIdRouteImport.update({
  id: '/admin/passport/$eventId',
  path: '/admin/passport/$eventId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminDemoQrGalleryRoute = AppAdminDemoQrGalleryRouteImport.update({
  id: '/admin/demo_/qr-gallery',
  path: '/admin/demo/qr-gallery',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminPassportActivitiesActivityIdRoute =
  AppAdminPassportActivitiesActivityIdRouteImport.update({
    id: '/admin/passport/activities/$activityId',
    path: '/admin/passport/activities/$activityId',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/badge': typeof BadgeRoute
  '/login': typeof LoginRoute
  '/scan-logs': typeof AppScanLogsRoute
  '/demo/enroll': typeof DemoEnrollRoute
  '/passport/events': typeof PassportEventsRoute
  '/passport/stamp': typeof PassportStampRoute
  '/passport/': typeof PassportIndexRoute
  '/admin/demo': typeof AppAdminDemoRoute
  '/admin/event-settings': typeof AppAdminEventSettingsRoute
  '/admin/staff': typeof AppAdminStaffRoute
  '/attendees/$id': typeof AppAttendeesIdRoute
  '/attendees/import': typeof AppAttendeesImportRoute
  '/passport/events/$eventId': typeof PassportEventsEventIdRoute
  '/passport/scan/$eventId': typeof PassportScanEventIdRoute
  '/attendees/': typeof AppAttendeesIndexRoute
  '/participants/': typeof AppParticipantsIndexRoute
  '/admin/demo/qr-gallery': typeof AppAdminDemoQrGalleryRoute
  '/admin/passport/$eventId': typeof AppAdminPassportEventIdRoute
  '/admin/passport/logs': typeof AppAdminPassportLogsRoute
  '/admin/passport/new': typeof AppAdminPassportNewRoute
  '/staff/scan/attendance': typeof AppStaffScanAttendanceRoute
  '/staff/scan/lunch': typeof AppStaffScanLunchRoute
  '/admin/passport/': typeof AppAdminPassportIndexRoute
  '/admin/passport/activities/$activityId': typeof AppAdminPassportActivitiesActivityIdRoute
}
export interface FileRoutesByTo {
  '/badge': typeof BadgeRoute
  '/login': typeof LoginRoute
  '/scan-logs': typeof AppScanLogsRoute
  '/demo/enroll': typeof DemoEnrollRoute
  '/passport/events': typeof PassportEventsRoute
  '/passport/stamp': typeof PassportStampRoute
  '/': typeof AppIndexRoute
  '/passport': typeof PassportIndexRoute
  '/admin/demo': typeof AppAdminDemoRoute
  '/admin/event-settings': typeof AppAdminEventSettingsRoute
  '/admin/staff': typeof AppAdminStaffRoute
  '/attendees/$id': typeof AppAttendeesIdRoute
  '/attendees/import': typeof AppAttendeesImportRoute
  '/passport/events/$eventId': typeof PassportEventsEventIdRoute
  '/passport/scan/$eventId': typeof PassportScanEventIdRoute
  '/attendees': typeof AppAttendeesIndexRoute
  '/participants': typeof AppParticipantsIndexRoute
  '/admin/demo/qr-gallery': typeof AppAdminDemoQrGalleryRoute
  '/admin/passport/$eventId': typeof AppAdminPassportEventIdRoute
  '/admin/passport/logs': typeof AppAdminPassportLogsRoute
  '/admin/passport/new': typeof AppAdminPassportNewRoute
  '/staff/scan/attendance': typeof AppStaffScanAttendanceRoute
  '/staff/scan/lunch': typeof AppStaffScanLunchRoute
  '/admin/passport': typeof AppAdminPassportIndexRoute
  '/admin/passport/activities/$activityId': typeof AppAdminPassportActivitiesActivityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/badge': typeof BadgeRoute
  '/login': typeof LoginRoute
  '/_app/scan-logs': typeof AppScanLogsRoute
  '/demo/enroll': typeof DemoEnrollRoute
  '/passport/events': typeof PassportEventsRoute
  '/passport/stamp': typeof PassportStampRoute
  '/_app/': typeof AppIndexRoute
  '/passport/': typeof PassportIndexRoute
  '/_app/admin/demo': typeof AppAdminDemoRoute
  '/_app/admin/event-settings': typeof AppAdminEventSettingsRoute
  '/_app/admin/staff': typeof AppAdminStaffRoute
  '/_app/attendees/$id': typeof AppAttendeesIdRoute
  '/_app/attendees/import': typeof AppAttendeesImportRoute
  '/passport/events_/$eventId': typeof PassportEventsEventIdRoute
  '/passport/scan/$eventId': typeof PassportScanEventIdRoute
  '/_app/attendees/': typeof AppAttendeesIndexRoute
  '/_app/participants/': typeof AppParticipantsIndexRoute
  '/_app/admin/demo_/qr-gallery': typeof AppAdminDemoQrGalleryRoute
  '/_app/admin/passport/$eventId': typeof AppAdminPassportEventIdRoute
  '/_app/admin/passport/logs': typeof AppAdminPassportLogsRoute
  '/_app/admin/passport/new': typeof AppAdminPassportNewRoute
  '/_app/staff/scan/attendance': typeof AppStaffScanAttendanceRoute
  '/_app/staff/scan/lunch': typeof AppStaffScanLunchRoute
  '/_app/admin/passport/': typeof AppAdminPassportIndexRoute
  '/_app/admin/passport/activities/$activityId': typeof AppAdminPassportActivitiesActivityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/badge'
    | '/login'
    | '/scan-logs'
    | '/demo/enroll'
    | '/passport/events'
    | '/passport/stamp'
    | '/passport/'
    | '/admin/demo'
    | '/admin/event-settings'
    | '/admin/staff'
    | '/attendees/$id'
    | '/attendees/import'
    | '/passport/events/$eventId'
    | '/passport/scan/$eventId'
    | '/attendees/'
    | '/participants/'
    | '/admin/demo/qr-gallery'
    | '/admin/passport/$eventId'
    | '/admin/passport/logs'
    | '/admin/passport/new'
    | '/staff/scan/attendance'
    | '/staff/scan/lunch'
    | '/admin/passport/'
    | '/admin/passport/activities/$activityId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/badge'
    | '/login'
    | '/scan-logs'
    | '/demo/enroll'
    | '/passport/events'
    | '/passport/stamp'
    | '/'
    | '/passport'
    | '/admin/demo'
    | '/admin/event-settings'
    | '/admin/staff'
    | '/attendees/$id'
    | '/attendees/import'
    | '/passport/events/$eventId'
    | '/passport/scan/$eventId'
    | '/attendees'
    | '/participants'
    | '/admin/demo/qr-gallery'
    | '/admin/passport/$eventId'
    | '/admin/passport/logs'
    | '/admin/passport/new'
    | '/staff/scan/attendance'
    | '/staff/scan/lunch'
    | '/admin/passport'
    | '/admin/passport/activities/$activityId'
  id:
    | '__root__'
    | '/_app'
    | '/badge'
    | '/login'
    | '/_app/scan-logs'
    | '/demo/enroll'
    | '/passport/events'
    | '/passport/stamp'
    | '/_app/'
    | '/passport/'
    | '/_app/admin/demo'
    | '/_app/admin/event-settings'
    | '/_app/admin/staff'
    | '/_app/attendees/$id'
    | '/_app/attendees/import'
    | '/passport/events_/$eventId'
    | '/passport/scan/$eventId'
    | '/_app/attendees/'
    | '/_app/participants/'
    | '/_app/admin/demo_/qr-gallery'
    | '/_app/admin/passport/$eventId'
    | '/_app/admin/passport/logs'
    | '/_app/admin/passport/new'
    | '/_app/staff/scan/attendance'
    | '/_app/staff/scan/lunch'
    | '/_app/admin/passport/'
    | '/_app/admin/passport/activities/$activityId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  BadgeRoute: typeof BadgeRoute
  LoginRoute: typeof LoginRoute
  DemoEnrollRoute: typeof DemoEnrollRoute
  PassportEventsRoute: typeof PassportEventsRoute
  PassportStampRoute: typeof PassportStampRoute
  PassportIndexRoute: typeof PassportIndexRoute
  PassportEventsEventIdRoute: typeof PassportEventsEventIdRoute
  PassportScanEventIdRoute: typeof PassportScanEventIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/badge': {
      id: '/badge'
      path: '/badge'
      fullPath: '/badge'
      preLoaderRoute: typeof BadgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passport/': {
      id: '/passport/'
      path: '/passport'
      fullPath: '/passport/'
      preLoaderRoute: typeof PassportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/passport/stamp': {
      id: '/passport/stamp'
      path: '/passport/stamp'
      fullPath: '/passport/stamp'
      preLoaderRoute: typeof PassportStampRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passport/events': {
      id: '/passport/events'
      path: '/passport/events'
      fullPath: '/passport/events'
      preLoaderRoute: typeof PassportEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/enroll': {
      id: '/demo/enroll'
      path: '/demo/enroll'
      fullPath: '/demo/enroll'
      preLoaderRoute: typeof DemoEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/scan-logs': {
      id: '/_app/scan-logs'
      path: '/scan-logs'
      fullPath: '/scan-logs'
      preLoaderRoute: typeof AppScanLogsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/participants/': {
      id: '/_app/participants/'
      path: '/participants'
      fullPath: '/participants/'
      preLoaderRoute: typeof AppParticipantsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/attendees/': {
      id: '/_app/attendees/'
      path: '/attendees'
      fullPath: '/attendees/'
      preLoaderRoute: typeof AppAttendeesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/passport/scan/$eventId': {
      id: '/passport/scan/$eventId'
      path: '/passport/scan/$eventId'
      fullPath: '/passport/scan/$eventId'
      preLoaderRoute: typeof PassportScanEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/passport/events_/$eventId': {
      id: '/passport/events_/$eventId'
      path: '/passport/events/$eventId'
      fullPath: '/passport/events/$eventId'
      preLoaderRoute: typeof PassportEventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/attendees/import': {
      id: '/_app/attendees/import'
      path: '/attendees/import'
      fullPath: '/attendees/import'
      preLoaderRoute: typeof AppAttendeesImportRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/attendees/$id': {
      id: '/_app/attendees/$id'
      path: '/attendees/$id'
      fullPath: '/attendees/$id'
      preLoaderRoute: typeof AppAttendeesIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/staff': {
      id: '/_app/admin/staff'
      path: '/admin/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AppAdminStaffRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/event-settings': {
      id: '/_app/admin/event-settings'
      path: '/admin/event-settings'
      fullPath: '/admin/event-settings'
      preLoaderRoute: typeof AppAdminEventSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/demo': {
      id: '/_app/admin/demo'
      path: '/admin/demo'
      fullPath: '/admin/demo'
      preLoaderRoute: typeof AppAdminDemoRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/passport/': {
      id: '/_app/admin/passport/'
      path: '/admin/passport'
      fullPath: '/admin/passport/'
      preLoaderRoute: typeof AppAdminPassportIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/staff/scan/lunch': {
      id: '/_app/staff/scan/lunch'
      path: '/staff/scan/lunch'
      fullPath: '/staff/scan/lunch'
      preLoaderRoute: typeof AppStaffScanLunchRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/staff/scan/attendance': {
      id: '/_app/staff/scan/attendance'
      path: '/staff/scan/attendance'
      fullPath: '/staff/scan/attendance'
      preLoaderRoute: typeof AppStaffScanAttendanceRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/passport/new': {
      id: '/_app/admin/passport/new'
      path: '/admin/passport/new'
      fullPath: '/admin/passport/new'
      preLoaderRoute: typeof AppAdminPassportNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/passport/logs': {
      id: '/_app/admin/passport/logs'
      path: '/admin/passport/logs'
      fullPath: '/admin/passport/logs'
      preLoaderRoute: typeof AppAdminPassportLogsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/passport/$eventId': {
      id: '/_app/admin/passport/$eventId'
      path: '/admin/passport/$eventId'
      fullPath: '/admin/passport/$eventId'
      preLoaderRoute: typeof AppAdminPassportEventIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/demo_/qr-gallery': {
      id: '/_app/admin/demo_/qr-gallery'
      path: '/admin/demo/qr-gallery'
      fullPath: '/admin/demo/qr-gallery'
      preLoaderRoute: typeof AppAdminDemoQrGalleryRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/passport/activities/$activityId': {
      id: '/_app/admin/passport/activities/$activityId'
      path: '/admin/passport/activities/$activityId'
      fullPath: '/admin/passport/activities/$activityId'
      preLoaderRoute: typeof AppAdminPassportActivitiesActivityIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppScanLogsRoute: typeof AppScanLogsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminDemoRoute: typeof AppAdminDemoRoute
  AppAdminEventSettingsRoute: typeof AppAdminEventSettingsRoute
  AppAdminStaffRoute: typeof AppAdminStaffRoute
  AppAttendeesIdRoute: typeof AppAttendeesIdRoute
  AppAttendeesImportRoute: typeof AppAttendeesImportRoute
  AppAttendeesIndexRoute: typeof AppAttendeesIndexRoute
  AppParticipantsIndexRoute: typeof AppParticipantsIndexRoute
  AppAdminDemoQrGalleryRoute: typeof AppAdminDemoQrGalleryRoute
  AppAdminPassportEventIdRoute: typeof AppAdminPassportEventIdRoute
  AppAdminPassportLogsRoute: typeof AppAdminPassportLogsRoute
  AppAdminPassportNewRoute: typeof AppAdminPassportNewRoute
  AppStaffScanAttendanceRoute: typeof AppStaffScanAttendanceRoute
  AppStaffScanLunchRoute: typeof AppStaffScanLunchRoute
  AppAdminPassportIndexRoute: typeof AppAdminPassportIndexRoute
  AppAdminPassportActivitiesActivityIdRoute: typeof AppAdminPassportActivitiesActivityIdRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppScanLogsRoute: AppScanLogsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminDemoRoute: AppAdminDemoRoute,
  AppAdminEventSettingsRoute: AppAdminEventSettingsRoute,
  AppAdminStaffRoute: AppAdminStaffRoute,
  AppAttendeesIdRoute: AppAttendeesIdRoute,
  AppAttendeesImportRoute: AppAttendeesImportRoute,
  AppAttendeesIndexRoute: AppAttendeesIndexRoute,
  AppParticipantsIndexRoute: AppParticipantsIndexRoute,
  AppAdminDemoQrGalleryRoute: AppAdminDemoQrGalleryRoute,
  AppAdminPassportEventIdRoute: AppAdminPassportEventIdRoute,
  AppAdminPassportLogsRoute: AppAdminPassportLogsRoute,
  AppAdminPassportNewRoute: AppAdminPassportNewRoute,
  AppStaffScanAttendanceRoute: AppStaffScanAttendanceRoute,
  AppStaffScanLunchRoute: AppStaffScanLunchRoute,
  AppAdminPassportIndexRoute: AppAdminPassportIndexRoute,
  AppAdminPassportActivitiesActivityIdRoute:
    AppAdminPassportActivitiesActivityIdRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  BadgeRoute: BadgeRoute,
  LoginRoute: LoginRoute,
  DemoEnrollRoute: DemoEnrollRoute,
  PassportEventsRoute: PassportEventsRoute,
  PassportStampRoute: PassportStampRoute,
  PassportIndexRoute: PassportIndexRoute,
  PassportEventsEventIdRoute: PassportEventsEventIdRoute,
  PassportScanEventIdRoute: PassportScanEventIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
